export const SKILLS_EVALUATIONS_D2C = "/api/folders/:param/skills-evaluation-d2c"
export const SKILLS_EVALUATION_D2C = "/api/folders/:param/skills-evaluation-d2c"

export const SKILLS_EVALUATION_D2C_GET_EDIT = "/api/folders/:param/skills-evaluation-d2c/:skillsEvaluationd2cFolderParam"
export const SKILLS_EVALUATION_D2C_DEACTIVATE = "/api/folders/:param/skills-evaluation-d2c/:skillsEvaluationd2cFolderParam/deactivate"
export const SKILLS_EVALUATION_D2C_ACTIVATE = "/api/folders/:param/skills-evaluation-d2c/:skillsEvaluationd2cFolderParam/activate"
